<template>
<div id='cursor-coord-container'>
  <b-row no-gutters v-if="elevation">
    <b-col class='p-1'>
      <div>Elevation: {{elevation}}</div>
    </b-col>
  </b-row>
  <b-row no-gutters>
    <b-col class='p-1' cols="4">
      <b-form-group>
        <b-form-select id="cursor-option" v-model="selected" :options="options" name="radioOpenions">
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col cols="6" class='p-1'>
      <div class="map-mouse-pointer">{{posStr}}</div>
    </b-col>
    <b-col class='p-1'>
      <div v-if="selected === 'MGA'" id='cursor-zone'>{{mgaZone}}</div>
    </b-col>
  </b-row>
</div>
</template>

<script>
import * as olProj from 'ol/proj'
import {
  EPSG_28355,
  EPSG_28356,
  EPSG_4283
} from '../../util/projections'
import proj4 from 'proj4'
import Projection from 'ol/proj/Projection'
import Point from 'ol/geom/Point'

proj4.defs('EPSG:28356', EPSG_28356)
proj4.defs('EPSG:28355', EPSG_28355)
proj4.defs('EPSG:4283', EPSG_4283)
olProj.addProjection(new Projection({
  code: 'EPSG:28356'
}))
olProj.addProjection(new Projection({
  code: 'EPSG:28355'
}))

export default {
  name: 'MapMousePointer',
  data() {
    return {
      posStr: 'no coords available',
      bSrid: 'EPSG:28356',
      options: ['MGA', 'GDA'],
      selected: 'MGA'
    }
  },
  methods: {
    onMove(e) {
      if (this.selected === 'MGA') {
        let coords = proj4(proj4('EPSG:3857'), proj4(this.bSrid || 'EPSG:28356')).forward(e.coordinate)
        this.posStr = coords.map(n => n.toFixed(3)).join(' ')
      } else {
        let coords = proj4(proj4('EPSG:3857'), proj4('EPSG:4283')).forward(e.coordinate)
        this.posStr = coords.map(n => n.toFixed(3)).join(' ')
      }
    },
    startListening() {
      if (this.$mapService) {
        this.$mapService.map.on('pointermove', this.onMove, this)
        this.bSrid = this.$store.getters['project/currentProject'].workpack.best_srid
      }

    }
  },
  computed: {
    mapInit() {
      return this.$store.getters['map/initialised']
    },
    elevation() {
      return this.$store.getters['map/context_elevation']
    },
    mgaZone() {
      switch (this.bSrid) {
        case this.bSrid === 'EPSG:28355':
          return 'Zone 55'
          break;
        default:
          return 'Zone 56'
      }
    }
  },
  watch: {
    mapInit(val) {
      if (val) {
        this.startListening()
      }
    }
  },
  mounted() {
    this.startListening()
  }
}
</script>

<style scoped>
#cursor-coord-container {
  background-color: whitesmoke;
  border-radius: 3px;
  border: 1px solid gray;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  font: 9pt Arial;
  width: 20rem;
  line-height: 2.2rem;
}

#cursor-coord-container .form-group {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/map/MapMousePointer.vue